import { useEffect } from "react";
import { useLastSubChapterId } from "@/hooks/course/useLastSubChapterId";
import { useCourseDetailStore } from "@/stores/courseDetailStore";

/**
 * Mirrors chapter-outro band focus onto TOC — highlights the last subchapter
 * while its content band is active; clears focus so Abschluss highlights when
 * the outro band is active.
 */
const useSyncOutroTocFocus = (outroActive: boolean) => {
  const lastSubchapterId = useLastSubChapterId();
  const setFocusedNodeId = useCourseDetailStore(
    (state) => state.setFocusedNodeId
  );

  useEffect(() => {
    if (!outroActive && lastSubchapterId) {
      setFocusedNodeId(lastSubchapterId);
    } else {
      setFocusedNodeId(null);
    }

    return () => {
      setFocusedNodeId(null);
    };
  }, [outroActive, lastSubchapterId, setFocusedNodeId]);
};

export { useSyncOutroTocFocus };
